import React, {useState} from 'react'
import {Link} from 'gatsby'
import './MenuHeader.scss'

export default function MenuHeader({menu}) {
	const [active, setActive] = useState(false)

	return(
		<ul className="MenuHeader">
			{
				menu.map((menuItem, i) =>
					<li
						className="MenuHeaderItem"
						key={`${menuItem.id}_${i}`}
					>
						{
							menuItem.path === '#'
							? 	<button aria-expanded={active} className={`expandButton ${active ? 'active' : ''}`} onKeyPress={() => { setActive(!active) }} onTouchStart={() => { setActive(!active) }}>
									{menuItem.label}
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 30">
										<path id="Polygon_6" data-name="Polygon 6" d="M17,0,34,30H0Z" />
									</svg>
								</button>
							: 	<Link
									className={menuItem.cssClasses ? menuItem.cssClasses.join(' ') : ''}
									to={menuItem.path}
								>
									{menuItem.label}
								</Link>
						}
						{
							menuItem.children.length > 0
							? 	<ul aria-hidden={!active} className={`MenuHeaderSubMenu ${active ? 'active' : ''}`} >
									{
										menuItem.children.map((subMenuItem, si) =>
											<li className="MenuHeaderSubMenuItem" key={`${subMenuItem.id}_${si}`}>
												<Link
													to={subMenuItem.path}
													onFocus={e => { e.currentTarget.parentElement.parentElement.parentElement.classList.add('focus') }}
													onBlur={e => { e.currentTarget.parentElement.parentElement.parentElement.classList.remove('focus') }}
												>
													{subMenuItem.label}
												</Link>
											</li>
										)
									}
								</ul>
							: null
						}
					</li>
				)
			}
		</ul>
	)
}